import { Box, Button, Card, Typography } from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import {useNavigate, useParams } from 'react-router-dom'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import dayjs from 'dayjs'
import { useDispatch } from 'react-redux';
import axiosInstance from '../../../api/axiosInstance';
import { removeData } from '../../../Redux/Feature/AdminSlice';
import FormatNumber from '../../../CommonComponents/FormatNumber';
import { toast } from 'react-toastify';

function ViewBookedService({showButton = true}) {
    const { id } = useParams()
    const [bookedService, setBookedService] = useState({})
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const fetchServiceData = async () => {
        try {
            const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}get-booked-service-by-id/${id}`)
            if(response.status === 200){
                setBookedService(response?.data?.data)
            }
        } catch (error) {
            console.log(error)
            if(error.response.status === 401 || error.response.status === 403){
                navigate('/Admin/login')
                dispatch(removeData())
            }
        }
    }

    useEffect(() => {
        if(id){
            fetchServiceData()
        }
    }, [id])

    const FileDisplayCard = ({ bookedService, name, heading }) => {

        const images = bookedService?.form_data?.[name];
        console.log(images)
      
        if (!images || !Array.isArray(images)) return null;
      
        return images.map((file, index) => {
          const fileUrl = `/${file.path.replaceAll("\\", "/")}`;
          const isImage = file.mimetype?.startsWith("image");
      
          return (
            <Card key={index} sx={{ mt: 2, p: 2 }}>
              <Typography fontWeight="bold">{heading}</Typography>
      
              {isImage ? (
                <img
                  src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
                  alt={file.originalname}
                  style={{ maxWidth: "100%", marginTop: 8, borderRadius: 8 }}
                />
              ) : (
                <iframe
                  src={`${process.env.REACT_APP_FILE_PATH}${file.filename}`}
                  title={file.originalname}
                  style={{ width: "100%", height: "300px", border: "1px solid #ccc", marginTop: 8 }}
                ></iframe>
              )}
            </Card>
          );
        });
      };


      const handleBookCompleteService = async () => {
        setLoading(true)
          try {
              const response = await axiosInstance.put(`${process.env.REACT_APP_API_URL}update-booked-service-to-order-complete/${id}`)
              if(response.status === 200){
                fetchServiceData()
                setLoading(false)
                toast.success('Service marked as complete')
              }
          } catch (error) {
              console.log(error)
              toast.error('Failed to mark service as complete')
              setLoading(false)
              if(error.response.status === 401 || error.response.status === 403){
                navigate('/Admin/login')
                dispatch(removeData())
            }
          }
      }


  return (
    <div>
        {showButton && (
 <Box>
 <ArrowBackIcon sx={{':hover' : {cursor : 'pointer'}}} onClick={() => navigate('/Admin/booked-services')}/>
</Box>
        )}
       

        <Card sx={{mt : 2, p : 2}}>
            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Name</Typography>
                <Typography>{bookedService?.form_data?.name}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Phone</Typography>
                <Typography>{bookedService?.form_data?.phone?.length > 0 ? <FormatNumber number={`+${bookedService?.form_data?.phone}`} /> : '-'}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Email</Typography>
                <Typography>{bookedService?.form_data?.email}</Typography>
            </Box>
        </Card>

        <Card sx={{mt : 2, p : 2}}>
            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Line</Typography>
                <Typography>{bookedService?.form_data?.line?.length > 0 ? `${bookedService?.form_data?.line}` : '-'}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>WeChat</Typography>
                <Typography>{bookedService?.form_data?.wechat?.length > 0 ? `${bookedService?.form_data?.wechat}` : '-'}</Typography>
            </Box>

            <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Whatsapp</Typography>
                <Typography>{bookedService?.form_data?.whatsapp?.length > 0 ? `${bookedService?.form_data?.whatsapp}` : '-'}</Typography>
            </Box>
        </Card>

            {bookedService?.form_data?.schoolAttended && (
                <Box sx={{mt : 2}}>
                    <Typography sx={{fontWeight : 700}}>School Attended</Typography>
                    <Typography>{bookedService?.form_data?.schoolAttended}</Typography>
                </Box>
            )}
            
            {bookedService?.form_data?.gradeYearOfStudy && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Grade Year of Study</Typography>
                <Typography>{bookedService?.form_data?.gradeYearOfStudy}</Typography>
            </Box>
            )}


{bookedService?.form_data?.package && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Package</Typography>
                <Typography>{bookedService?.form_data?.package?.title}</Typography>
            </Box>
            )}

{bookedService?.form_data?.package && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Package Amount</Typography>
                <Typography>S$ {bookedService?.form_data?.package?.amount}</Typography>
            </Box>
            )}

{bookedService?.form_data?.startDate && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Start Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.startDate).format("DD/MM/YYYY hh:mm A")}</Typography>
            </Box>
            )}
            
            {bookedService?.form_data?.enlishTrialClassDate && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>English Trial Class Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.enlishTrialClassDate).format("DD/MM/YYYY")}</Typography>
            </Box>
            )}
            {bookedService?.form_data?.englishTrialClassTime && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>English Trial Class Time</Typography>
                <Typography>{bookedService?.form_data?.englishTrialClassTime}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.flightno && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Flight No</Typography>
                <Typography>{bookedService?.form_data?.flightno}</Typography>
            </Box>
            )}

{bookedService?.form_data?.luggageCount && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Luggage Count</Typography>
                <Typography>{bookedService?.form_data?.luggageCount}</Typography>
            </Box>
            )}

{bookedService?.form_data?.pickUpLocation && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Pick Up Location</Typography>
                <Typography>{bookedService?.form_data?.pickUpLocation}</Typography>
            </Box>
            )}

            {bookedService?.form_data?.arrival_date && (
                <Box sx={{mt : 2}}>
                <Typography sx={{fontWeight : 700}}>Arrival Date</Typography>
                <Typography>{dayjs(bookedService?.form_data?.arrival_date).format("DD/MM/YYYY hh:mm A")}</Typography>
            </Box>
            )}
   

        {bookedService?.form_data?.img && (
            <FileDisplayCard bookedService={bookedService} name={'img'} heading={'Passport'}/>
        )}

        {bookedService?.form_data?.ipa && (
            <FileDisplayCard bookedService={bookedService} name={'ipa'} heading={'IPA'}/>
        )}

            {bookedService?.form_data?.passport && (
            <FileDisplayCard bookedService={bookedService} name={'passport'} heading={'Passport'}/>
        )}

        {showButton && (
            <Box sx={{mt : 2, display : 'flex', gap : 2, justifyContent : 'flex-end'}}>
                {/* <Button variant='contained'>Order Pending</Button> */}
                <Button disabled={bookedService?.order_complete_status === true || loading} variant='contained' onClick={() => handleBookCompleteService()}>Order Complete</Button>
        </Box>
        )}
        
    </div>
  )
}

export default ViewBookedService